import { useState } from 'react';
import styles from './About.module.css';

/** Collapsible "how this works / is this legal?" panel — credibility + ethics. */
export function About() {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.wrap}>
      <button className={styles.toggle} onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span className={styles.q}>?</span> How this works {open ? '▲' : '▼'}
      </button>
      {open && (
        <div className={styles.body}>
          <p>
            <strong>What am I looking at?</strong> Every server on the public internet gets probed
            within minutes by automated bots hunting for <code>/wp-admin</code>, <code>.env</code>{' '}
            files, default passwords, and old exploits. This is a <em>honeypot</em> — a deliberately
            exposed fake server that does nothing but log those probes and put them on stage.
          </p>
          <p>
            <strong>Is it real?</strong> The attacks are 100% real, live, unsolicited traffic. The
            server they're hitting is fake: it serves convincing-but-empty decoy pages and captures
            whatever the bots try. Geolocation comes free from Cloudflare's edge — no external
            tracking.
          </p>
          <p>
            <strong>Is this legal?</strong> Yes. A passive honeypot only <em>observes</em> traffic
            sent to it — it never scans, probes, or retaliates against anyone. That's standard,
            long-established security practice.
          </p>
          <p>
            <strong>Privacy.</strong> Source IPs are truncated to a <code>/24</code> before they're
            ever displayed — never shown in full. The passwords are the bots' own guesses, not
            anyone's real secrets. Nothing here connects to real infrastructure; every "secret" in
            the decoys is an obvious fake sentinel.
          </p>
        </div>
      )}
    </div>
  );
}
